import { render, staticRenderFns } from "./WarningBanner.vue?vue&type=template&id=f01e652a&scoped=true&"
import script from "./WarningBanner.vue?vue&type=script&lang=ts&"
export * from "./WarningBanner.vue?vue&type=script&lang=ts&"
import style0 from "./WarningBanner.vue?vue&type=style&index=0&id=f01e652a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01e652a",
  null
  
)

export default component.exports